import { formatDate } from "date-fns";
import { eachDayOfInterval } from "date-fns";

export function generateRandomHashKey() {
  // Generate a random number between 1000 and 9999
  const randomKey = Math.floor(1000 + Math.random() * 9000);
  return randomKey.toString();
}
